import { CopilotApprovalOperationOutcome } from './CopilotApprovalDetailsModal';

export const formatApprovalDetailsValue = (value: unknown): string => {
  if (value === undefined || value === null) return '';
  if (typeof value === 'string') return value;

  try {
    return JSON.stringify(value, null, 2) ?? '';
  } catch {
    return String(value);
  }
};

export const getApprovalOperationOutcome = (value: unknown): CopilotApprovalOperationOutcome | undefined => {
  if (typeof value !== 'string') return undefined;

  return Object.values(CopilotApprovalOperationOutcome).includes(value as CopilotApprovalOperationOutcome)
    ? (value as CopilotApprovalOperationOutcome)
    : undefined;
};
